/* import logo from './logo.svg';
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App; */
import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Achievements from './components/Achievements';
import Counts from './components/Counts';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Portfolio from './components/Portfolio';
import './App.css';
import Team from './components/Team';
import CookieConsent from 'react-cookie-consent';


function App() {
  return (
    <div>
      <Header />
      <Hero />
      <About />
      <Services />
      <Achievements />
      <Counts />
      <Portfolio/>
      <Team/>
      <Contact />
      <Footer />
      <CookieConsent
        location="bottom"
        buttonText="I Understand"
        cookieName="sevenkyCookieConsent"
        style={{ background: "#2B373B" }}
        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
        expires={150}
      >
        This website uses cookies to enhance user experience.{" "}
        <a href="/privacy-policy" style={{ color: "#ffd700" }}>
          Learn more
        </a>
      </CookieConsent>



    </div>
  );
}

export default App;

